<template>
  <v-dialog
    :value="value"
    @input="closeModal()"
  >
    <v-card
      class="pa-0 px-3"
      :class="{ 'pt-3': !withDiscountInput }"
    >
      <v-form
        ref="form"
        v-model="form"
      >
        <v-expansion-panels
          v-if="value"
          accordion
          focusable
        >
          <v-expansion-panel
            v-for="(group, index) in menu"
            :key="index"
            :disabled="disabledGroupIdDict[group.id]"
          >
            <v-expansion-panel-header v-if="currentData.products">
              <v-row
                class="ma-0"
                align="center"
              >
                <v-checkbox
                  :input-value="!!findGroup(group.id)"
                  readonly
                  @click.stop="disabled ? void 0 : toggleGroup(group.id)"
                  hide-details
                  class="ma-0"
                  :disabled="disabled || disabledGroupIdDict[group.id]"
                />
                <b class="mt-2">{{ group.name }}</b>
                <div
                  class="ml-3 text-body-2"
                  style="margin-top: 8px"
                >
                  {{ groupStatusText(group) }}
                </div>
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="mt-2">
              <v-row
                class="ma-0"
                v-for="(product, index) in group.items"
                :key="product.id"
                :class="{ 'mt-3': index }"
              >
                <v-checkbox
                  :input-value="isProductSelected(product)"
                  hide-details
                  readonly
                  class="ma-0"
                  @click="
                    disabled || disabledProductIdDict[product.id]
                      ? void 0
                      : toggle(product, product.group)
                  "
                  :disabled="disabled || disabledProductIdDict[product.id]"
                />
                <v-row
                  no-gutters
                  align="center"
                  class="mt-1"
                  :class="{ 'grey--text': disabledProductIdDict[product.id] }"
                  @click="openProduct(product)"
                  :style="{
                    cursor: !ingredientsSelectorDisabled ? 'pointer' : ''
                  }"
                >
                  {{ product.name || product.vendor_name }}
                  <div
                    class="ml-3 text-caption"
                    v-if="!ingredientsSelectorDisabled"
                  >
                    {{ productStatusText(product) }}
                  </div>
                </v-row>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        <div
          class="pt-5 pb-3"
          style="position: sticky; bottom: 0; z-index: 1; background: white"
        >
          <v-btn
            color="primary"
            @click="closeModal()"
            :disabled="!form || !buttonActive"
          >
            <div class="text-none">Применить</div>
          </v-btn>
        </div>
      </v-form>
    </v-card>
    <OneProductDialog
      v-model="productModal"
      :product="productToOpen"
      :selected-ingredient="productSelectedIngredient"
      :is-product-selected="isProductToOpenSelected"
      @updateIngredients="updateSelectedIngredients($event, productToOpen)"
      :disabled="disabled"
      :ingredients-selector-disabled="ingredientsSelectorDisabled"
      :selectedIngredients="selectedIngredients"
    />
  </v-dialog>
</template>

<script>
  import { cloneDeep } from 'lodash'
  import OneProductDialog from './OneProductDialog.vue'
  import rules from 'air-vue-model/rules'

  export default {
    name: 'OneProductsSelector',
    computed: {
      rules() {
        return rules
      },
      buttonActive() {
        if (this.currentData.products[0]) {
          return this.containsIngredient(this.currentData.products[0])
        } else {
          return false
        }
      },
      disabledGroupIdDict() {
        const res = {}
        for (const el of this.menu) {
          res[el.id] = this.disabledGroupIds && this.disabledGroupIds.includes(el.id)
        }
        return res
      },
      disabledProductIdDict() {
        const res = {}
        for (const group of this.menu) {
          for (const product of group.items) {
            res[product.id] = this.disabledGroupIds && this.disabledProductIds.includes(product.id)
          }
        }
        return res
      }
    },
    components: { OneProductDialog },
    data: () => ({
      currentData: { products: [] },
      form: null,
      productToOpen: null,
      productModal: false,
      isProductToOpenSelected: false,
      productSelectedIngredient: null
    }),
    props: {
      value: Boolean,
      productsData: Array,
      withDiscountInput: Boolean,
      menu: Array,
      disabled: Boolean,
      ingredientsSelectorDisabled: Boolean,
      selectedProductsLimit: Number,
      selectedGroupsLimit: Number,
      disabledGroupIds: Array,
      disabledProductIds: Array,
      selectedIngredients: Array
    },
    emits: ['input', 'updateProductsData'],
    methods: {
      extractSelectedIngredient(data) {
        if (!data || !data[0] || !data[0].products) {
          return null
        }

        for (const group of data[0].products) {
          if (group.type === 'product_group' && Array.isArray(group.children)) {
            for (const product of group.children) {
              if (
                product.type === 'product' &&
                Array.isArray(product.children) &&
                product.children.length > 0
              ) {
                const ingredient = product.children.find(child => child.type === 'ingredient')

                if (ingredient) {
                  return {
                    product_id: product.product_id,
                    ingredient_id: ingredient.product_id,
                    image: ingredient.image || '',
                    name: ingredient.name || ''
                  }
                }
              }
            }
          }
        }

        return null
      },
      closeModal() {
        console.log(JSON.stringify([this.currentData]))
        const data = this.extractSelectedIngredient([this.currentData])
        console.log(JSON.stringify(data))
        this.$emit('input', false)
        this.$emit('updateProductsData', data)
      },
      isProductSelected(product) {
        const group = this.findGroup(product.group)
        if (!group) return false
        return group.children.some(v => v.product_id === product.id)
      },
      toggleGroup(groupId) {
        const groupIndex = this.currentData.products.findIndex(
          v => v.product_id === groupId && v.type === 'product_group'
        )

        if (groupIndex > -1) {
          this.currentData.products.splice(groupIndex, 1)
        } else {
          this.currentData.products = []
          this.currentData.products.push({
            product_id: groupId,
            type: 'product_group',
            children: []
          })
        }
      },
      toggle(product, groupId) {
        const isSelected = this.isProductSelected(product)

        if (isSelected) {
          const group = this.findGroup(groupId)
          if (group) {
            const index = group.children.findIndex(v => v.product_id === product.id)
            if (index > -1) {
              group.children.splice(index, 1)
              if (group.children.length === 0) {
                const groupIndex = this.currentData.products.findIndex(
                  v => v.product_id === groupId && v.type === 'product_group'
                )
                if (groupIndex > -1) {
                  this.currentData.products.splice(groupIndex, 1)
                }
              }
            }
          }
        } else {
          this.currentData.products = []
          this.currentData.products.push({
            type: 'product_group',
            product_id: groupId,
            children: [
              {
                product_id: product.id,
                type: 'product',
                children: []
              }
            ]
          })
        }
      },
      findGroup(id) {
        return this.currentData.products.find(
          v => v.product_id === id && v.type === 'product_group'
        )
      },
      findProductInStructure(productId) {
        for (const group of this.currentData.products) {
          if (group.type === 'product_group') {
            const product = group.children.find(
              v => v.product_id === productId && v.type === 'product'
            )
            if (product) return product
          }
        }
        return null
      },
      getSelectedIngredient(product) {
        const found = this.findProductInStructure(product.id)
        if (!found || !found.children || found.children.length === 0) return null
        const ingredient = found.children[0]
        return {
          id: ingredient.product_id,
          image: ingredient.image || '',
          name: ingredient.name || ''
        }
      },
      updateSelectedIngredients(newSelectedIngredients, product) {
        const selectedIngredient = newSelectedIngredients.selected

        if (selectedIngredient) {
          const ingredientData = {
            product_id: selectedIngredient.id,
            type: 'ingredient',
            image: selectedIngredient.image,
            name: selectedIngredient.name,
            children: []
          }

          this.currentData.products = []

          const groupId = product.group && product.group.id ? product.group.id : product.group

          this.currentData.products.push({
            type: 'product_group',
            product_id: groupId,
            children: [
              {
                type: 'product',
                product_id: product.id,
                children: [ingredientData]
              }
            ]
          })
        } else {
          // Ингредиент снят — очищаем всё
          this.currentData.products = []
        }
      },
      openProduct(product) {
        if (this.ingredientsSelectorDisabled) return
        void this.$product.loadItem(product.id).then(res => {
          this.productToOpen = res
          this.productModal = true
          this.isProductToOpenSelected = this.isProductSelected(product)
          this.productSelectedIngredient = this.getSelectedIngredient(product)
        })
      },
      groupStatusText(group) {
        const groupData = this.findGroup(group.id)
        if (!groupData) return ''

        for (const product of groupData.children) {
          if (product.children && product.children.length > 0) {
            const ingredient = product.children[0]
            return ingredient.name || ''
          }
        }

        return ''
      },
      productStatusText(product) {
        const productData = this.findProductInStructure(product.id)
        if (!productData || !productData.children || productData.children.length === 0) {
          return ''
        }

        const selectedIngredient = productData.children[0]
        return selectedIngredient.name || ''
      },

      containsIngredient(product) {
        if (!product) return false
        if (product.type == 'ingredient') {
          return true
        }

        if (product.children[0]) {
          return this.containsIngredient(product.children[0])
        } else {
          return false
        }
      }
    },
    watch: {
      value(v) {
        if (v) {
          if (this.productsData && this.productsData.length > 0) {
            this.currentData = cloneDeep(this.productsData[0])
          } else {
            this.currentData = cloneDeep({ products: [] })
          }
        }
      }
    }
  }
</script>

<style scoped>
  :deep(.v-expansion-panel::before) {
    box-shadow: unset !important;
  }

  :deep(.v-expansion-panel:last-child::before) {
    border-bottom: thin solid;
    border-color: rgba(0, 0, 0, 0.12);
    bottom: -1px;
    height: 1px;
    top: unset;
  }
</style>
